import deepmerge from 'deepmerge';
import { Laboratory, Patient } from '.';
import capitalize from '../utils/capitalize';

export type ITestResultEntity = {
  id: string;
  key?: string;
  tested_at: string;
  expired_at: string;
  type: string;
  laboratory?: Laboratory;
  patient?: Patient;
};

export interface ITestResult {
  id: string;
  key?: string;
  tested_at: Date;
  expired_at: Date;
  type: string;
  laboratory?: Laboratory;
  patient?: Patient;
}

export default class TestResult implements ITestResult {
  id = '';
  key?: string;
  tested_at = new Date();
  expired_at = new Date();
  type = '';
  laboratory?: Laboratory;
  patient?: Patient;

  constructor(obj: Partial<ITestResult>) {
    Object.assign(this, obj);
  }

  update(obj: Partial<ITestResult>) {
    Object.assign(this, obj);
    return this;
  }

  getDayString() {
    return capitalize(
      this.tested_at.toLocaleDateString('fr-FR', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    );
  }

  getHourString() {
    let hourString = `${String(this.tested_at.getHours()).padStart(
      2,
      '0'
    )}h${String(this.tested_at.getMinutes()).padStart(2, '0')}`;

    return hourString;
  }

  copyWith(obj: Partial<ITestResult>) {
    return new TestResult(deepmerge(Object.assign({}, this), obj));
  }

  static createFromEntity(obj: Partial<ITestResultEntity>) {
    return new TestResult({
      id: obj.id,
      key: obj.key,
      tested_at: obj.tested_at ? new Date(obj.tested_at) : undefined,
      expired_at: obj.expired_at ? new Date(obj.expired_at) : undefined,
      type: obj.type,
      patient: obj.patient ? Patient.createFromEntity(obj.patient) : undefined,
      laboratory: obj.laboratory ? new Laboratory(obj.laboratory) : undefined
    });
  }

  toEntity() {
    return {
      id: this.id,
      key: this.key,
      tested_at: this.tested_at.toISOString(),
      expired_at: this.expired_at.toISOString(),
      type: this.type
    };
  }
}
